/** Shown when the backend refuses a save because the report changed since this tab loaded it. */
export const REPORT_CHANGED_MESSAGE =
  'This report was changed elsewhere (another tab or another person). Reload the page to continue — your unsaved edits are still on screen.';

/**
 * Thrown when a save is refused with 409 "report_changed": another tab or person saved (or
 * restored) the report after this tab loaded it, so saving now would overwrite their work.
 */
export class ReportChangedError extends Error {
  constructor(message: string = REPORT_CHANGED_MESSAGE) {
    super(message);
    this.name = 'ReportChangedError';
  }
}

export const isReportChangedError = (error: unknown): error is ReportChangedError =>
  error instanceof ReportChangedError || (error as Error | undefined)?.name === 'ReportChangedError';
